@let contactData = configuration().contactData;
@let partnerLinks = configuration().partnerLinks;

<div class="container costum-mat-primary-container">
    <div class="contact">
        <div class="custom-title-large header">Kontakt</div>

        <div class="custom-title-medium title">Addresse</div>
        <div class="custom-body-medium">{{contactData.name}}</div>
        <div class="custom-body-medium">{{contactData.street}}</div>
        <div class="custom-body-medium">{{contactData.city}}</div>

        <div class="custom-title-medium title">Öffnungszeiten</div>

        <app-opening-hours [classes]="'custom-body-medium'"></app-opening-hours>

        <div class="custom-title-medium title">Kontakt</div>
        <div class="contact-container">
            <div class="custom-body-medium">Telefon:</div>
            <div class="custom-body-medium">{{contactData.phone}}</div>
            @if (contactData.mobile) {
                <div class="custom-body-medium">Mobil:</div>
                <div class="custom-body-medium">{{contactData.mobile}}</div>
            }
            <div class="custom-body-medium">E-Mail:</div>
            <a  class="custom-body-medium costum-mat-primary-font-color" (click)="sendEmail()">{{contactData.email}}</a>
        </div>

    </div>
    <div class="info">
        <div class="custom-title-large header">Informationen</div>
        <div class="custom-title-medium links"><a (click)="scrollService.navigateAndScrollTo('/', 'about-us')">Über uns</a>
        </div>
        <div class="custom-title-medium links"><a routerLink="/impressum" target="_blank" class="no-webkit-link">Impressum</a></div>
        <div class="custom-title-medium links"><a routerLink="/datenschutz" target="_blank" class="no-webkit-link">Datenschutz</a></div>
        <div class="custom-title-medium links"><a (click)="openCookieConsent()" data-cc="show-preferencesModal">Cookies</a></div>

        @if(partnerLinks.length > 0) {
            <div class="custom-title-medium title">Partner:</div>
            @for(partnerLink of partnerLinks; track $index) {
                <div class="custom-body-medium links"><a href="{{partnerLink.url}}" target="_blank" class="no-webkit-link">{{partnerLink.name}}</a></div>
            } 
        }
    </div>

    <div class="branding">
        <div class="custom-headline-medium">{{contactData.name}}</div>
        <!-- <p class="custom-label-medium">© 2024 All rights reserved</p> -->
    </div>
</div>